export interface SCardProps {
    padding?: string;
    children?: React.ReactNode;
    insideClassName?: string;
}

export function SCard(props: SCardProps) {
    const padding = props.padding ? `p-${props.padding}` : 'p-4';
    return (
        <div className={`bg-bg-fill border border-(--color-border) rounded-xl ${padding} ${props.insideClassName}`}>
            {props.children}
        </div>
    );
}
